import { render, staticRenderFns } from "./NewGame.vue?vue&type=template&id=788f60e8&scoped=true&"
import script from "./NewGame.vue?vue&type=script&lang=js&"
export * from "./NewGame.vue?vue&type=script&lang=js&"
import style0 from "./NewGame.vue?vue&type=style&index=0&id=788f60e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788f60e8",
  null
  
)

export default component.exports